export const useLandDataStore = defineStore('user', {
    state: () => ({
        landPageData: null, // 落地页数据
        monetization: 0, // 落地页支付方式
        monetizationObj: {}
    }),

    getters: {
    },

    actions: {
        setLandPageData(data: any) {
            this.landPageData = data
        },
        setMonetization(data: any) {
            this.monetization = data
        },
        setMonetizationObj(data: any) {
            this.monetizationObj = data
        },
    },
})
